import { OpsSupportSessionResponseSchema } from "../../shared/operations-schemas";
import {
  SupportAccessRequestCreateSchema,
  SupportAccessRequestResponseSchema,
  SupportAccessRequestsResponseSchema,
  type SupportAccessRequestCreate,
} from "../../shared/support-access-schemas";
import { parseResponse } from "../api/client-core";

/**
 * Asking a customer for support access, from the operations console (ADR-0072).
 *
 * Kept out of `api.ts` only because that file is at the repository's size limit; these three calls
 * belong to the same surface as the support-session calls beside them.
 */

const API_ROOT = "/api/ops";

function customerPath(organizationId: string): string {
  return `${API_ROOT}/customers/${encodeURIComponent(organizationId)}/support-access-requests`;
}

export async function listSupportAccessRequests(organizationId: string) {
  return parseResponse(
    await fetch(customerPath(organizationId), { credentials: "same-origin" }),
    SupportAccessRequestsResponseSchema,
  );
}

export async function requestSupportAccess(
  organizationId: string,
  input: SupportAccessRequestCreate,
) {
  return parseResponse(
    await fetch(customerPath(organizationId), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(SupportAccessRequestCreateSchema.parse(input)),
    }),
    SupportAccessRequestResponseSchema,
  );
}

/** Opening a session under an approval the customer already granted. */
export async function startApprovedSupportSession(organizationId: string, requestId: string) {
  return parseResponse(
    await fetch(`${customerPath(organizationId)}/${encodeURIComponent(requestId)}/sessions`, {
      method: "POST",
      credentials: "same-origin",
    }),
    OpsSupportSessionResponseSchema,
  );
}
